export const MINIMIZE_BUTTON_ICON = (
    <svg className="minimize-btn" viewBox="0 0 16 10">
        <polyline
            fill="none"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#000000"
            points="2 2 8 8 14 2"
        ></polyline>
    </svg>
);

export const MAXIMIZE_BUTTON_ICON = (
    <svg className="maximize-btn" viewBox="0 0 16 10">
        <polyline
            fill="none"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="#000000"
            points="2 8 8 2 14 8"
        ></polyline>
    </svg>
);

export const CLOSE_BUTTON_ICON = (
    <svg className="close-btn" viewBox="0 0 12 12">
        <path d="M0 0 L12 12" strokeWidth="3" stroke="#000000"></path>
        <path d="M0 12 L12 0" strokeWidth="3" stroke="#000000"></path>
    </svg>
);
